/*
 * @Auther: 罗耀祖
 * @Date: 2021-08-11 09:38:34
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-06-29 10:44:54
 * @name: 入口文件
 * @Description: 入口文件
 * @FilePath: \preSaleNafterSaleBackstage\src\entrance.js
 * @Author: DESKTOP-1QU67QM
 */
import router from './router'
import cookie from '@/storage/cookie'; //cookie对象
import unNeedToken from '@/config/unNeedToken.config';

router.beforeEach(async(to, from, next) => {
  const token = new cookie().getToken();
  if (token) {
    if (to.path === '/login') {
      next({ path: '/' });
    } else {
      next();
    }
  } else {
    // 没有token未登录
    if (unNeedToken.includes(to.path)) {
      next();
    } else {
      next(`/login`);
    }
  }
})